var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"attach":"#app"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("activator",null,null,{ on, attrs })]}}],null,true),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{style:({
      position: 'relative',
      height: _vm.$vuetify.breakpoint.height - 100 + 'px'
    })},[_c('v-btn',{style:({
        position: 'absolute',
        top: '25px',
        right: '55px',
        zIndex: 99
      }),attrs:{"text":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-close")]),_vm._v(" close")],1),_c('div',{staticStyle:{"height":"100% !important","overflow":"auto"}},[_c('v-img',{attrs:{"contain":"","src":_vm.value}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }